import { render, staticRenderFns } from "./DoctorHorarioForm.vue?vue&type=template&id=579134c7&scoped=true"
import script from "./DoctorHorarioForm.vue?vue&type=script&lang=js"
export * from "./DoctorHorarioForm.vue?vue&type=script&lang=js"
import style0 from "./DoctorHorarioForm.vue?vue&type=style&index=0&id=579134c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579134c7",
  null
  
)

export default component.exports